import { IHoaDonDieuChinhThuCongActionTypes } from "../../action-types/hoa-don/IHoaDonDieuChinhThuCongAction";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IHoaDonDieuChinhThuCongReducer } from "../../reducer-model/hoa-don/IHoaDonDieuChinhThuCongReducer";

const iniState: IHoaDonDieuChinhThuCongReducer = {
  status: eReducerStatusBase.is_not_initialization,
  isShowModal: false,
  items: [],
  version: 0,
};

export const hoaDonDieuChinhThuCongReducer = (
  state: IHoaDonDieuChinhThuCongReducer = iniState,
  action: IHoaDonDieuChinhThuCongActionTypes,
): IHoaDonDieuChinhThuCongReducer => {
  switch (action.type) {
    case "HOA_DON_DIEU_CHINH_THU_CONG_SHOW_MODAL":
      return { ...state, isShowModal: true, target: action.payload, items: [] };
    case "HOA_DON_DIEU_CHINH_THU_CONG_CLOSE_MODAL":
      return { ...state, isShowModal: false, target: undefined, items: [] };

    case "HOA_DON_DIEU_CHINH_THU_CONG_LOAD_START":
      return { ...state, status: eReducerStatusBase.is_loading };
    case "HOA_DON_DIEU_CHINH_THU_CONG_LOAD_SUCCESS":
      return { ...state, status: eReducerStatusBase.is_completed, items: action.payload };
    case "HOA_DON_DIEU_CHINH_THU_CONG_LOAD_ERROR":
      return { ...state, status: eReducerStatusBase.is_completed };

    case "HOA_DON_DIEU_CHINH_THU_CONG_SAVE_START":
    case "HOA_DON_DIEU_CHINH_THU_CONG_HUY_START":
      return { ...state, status: eReducerStatusBase.is_saving };
    case "HOA_DON_DIEU_CHINH_THU_CONG_SAVE_SUCCESS":
    case "HOA_DON_DIEU_CHINH_THU_CONG_HUY_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        items: action.payload,
        version: state.version + 1,
      };
    case "HOA_DON_DIEU_CHINH_THU_CONG_SAVE_ERROR":
    case "HOA_DON_DIEU_CHINH_THU_CONG_HUY_ERROR":
      return { ...state, status: eReducerStatusBase.is_completed };
    default:
      return state;
  }
};
